module.exports = __webpack_public_path__ + "img/20190628161035552.9b4e1e5e.png";